import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{
    ids: string[];
    action: string;
}>;

export const DispatchHandleVmiBinsChangedQty: HandlerType = props => {
    props.dispatch({
        type: "Pages/VmiBins/HandleVmiBinsChangedQty",
        ids: props.parameter.ids,
        action: props.parameter.action,
    });
};

export const chain = [DispatchHandleVmiBinsChangedQty];

const handleVmiBinsChangedQty = createHandlerChainRunner(chain, "handleVmiBinsChangedQty");
export default handleVmiBinsChangedQty;
